export default __webpack_public_path__ + "static/media/Blood donation project.9866cc8c.webp";